import { Clinic, Post } from "@ambii-com/core";
import {
  liteCollections,
  liteGetDocument,
  liteQueryCollectionWith,
  liteQueryCollectionOrderedLimited,
} from "~/utils/firestoreLite";

function toDate(value: unknown): Date {
  if (value instanceof Date) {
    return value;
  }
  if (
    value &&
    typeof value === "object" &&
    typeof (value as { toDate?: () => Date }).toDate === "function"
  ) {
    return (value as { toDate: () => Date }).toDate();
  }
  const timestamp = value as {
    seconds?: number;
    _seconds?: number;
    nanoseconds?: number;
    _nanoseconds?: number;
  };
  const seconds = timestamp?.seconds ?? timestamp?._seconds;
  if (typeof seconds === "number") {
    const nanoseconds = timestamp.nanoseconds ?? timestamp._nanoseconds ?? 0;
    return new Date(seconds * 1000 + nanoseconds / 1e6);
  }
  if (typeof value === "string") {
    const ms = Date.parse(value);
    return Number.isFinite(ms) ? new Date(ms) : new Date(0);
  }
  return new Date(0);
}

export async function readClinic(clinicId: string): Promise<Clinic> {
  return liteGetDocument(liteCollections.clinics, clinicId).then(Clinic.fromDoc);
}

export async function readAllClinics(): Promise<Clinic[]> {
  const docs = await liteQueryCollectionWith(liteCollections.clinics);
  return Clinic.fromDocs(docs);
}

export async function readPostsByClinicId(
  clinicId: string,
  max = 20
): Promise<Post[]> {
  const docs = await liteQueryCollectionOrderedLimited(
    liteCollections.posts,
    "createdAt",
    "desc",
    max,
    ["clinicId", "==", clinicId]
  );
  return docs
    .map((doc) => {
      const post = Post.fromDoc(doc);
      post.createdAt = toDate(post.createdAt);
      if (post.updatedAt) {
        post.updatedAt = toDate(post.updatedAt);
      }
      return post;
    });
}
